import { __assign, __rest } from "tslib";
import * as React from 'react';
import { default as MuiListItem, } from '@material-ui/core/ListItem';
export var ListItem = React.forwardRef(function (props, ref) {
    var button = props.button, removeLiWrap = props.removeLiWrap, other = __rest(props, ["button", "removeLiWrap"]);
    var Wrap = button && !removeLiWrap ? 'li' : React.Fragment;
    // button as any - https://github.com/mui-org/material-ui/issues/14971
    return (React.createElement(Wrap, null,
        React.createElement(MuiListItem, __assign({ ref: ref, button: button }, other))));
});
export default ListItem;
//# sourceMappingURL=ListItem.js.map